// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-329240eb]{padding:0;margin:0}span[data-v-329240eb]{-webkit-user-select:text;-moz-user-select:text;user-select:text}.showSpace[data-v-329240eb]{white-space:pre-wrap}", ""]);
// Exports
module.exports = exports;
